<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <corporation-new-form>
          </corporation-new-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import CorporationNewForm from './Corporations/CorporationNewForm.vue'

  export default {
    components: {
      CorporationNewForm,
    }
  }

</script>
<style>

</style>
